import cdkOutput from '../../../Backend/output.json';

export const environment = {
  production: false,
  apiURL: 'api.test.recimate.com/test',
  cdkOutput: {
    CognitoStack: {
      PoolId: 'us-east-2_awDFl9FM5',
      ClientId: '1jrh6r18rgkkm6c9p9i2kd2bf6',
    },
    FrontendStack: {
      CloudFormationDomain: 'dtuhzsk8eq9vy.cloudfront.net',
    },
  },
};
